import React from "react";
import { Paper } from "@mui/material";
import { TextField } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "0",
    margin: "0 0 20px 0",
  },
}));

const Searchbox = ({
  onChange,
  onSelect,
  placeholder,
  className,
  options,
  getOptionLabel,
  style,
  titleSearch,
}) => {
  const classes = useStyles();

  const textFieldProps = {
    variant: "outlined",
    fullWidth: true,
    placeholder,
    onChange,
  };

  return (
    <Paper className={`${className} ${classes.paper} paper`} style={style}>
      {options ? (
        <Autocomplete
          placeholder={titleSearch}
          onChange={(e, item) => onSelect(item)}
          options={options}
          getOptionLabel={getOptionLabel}
          renderInput={(params) => (
            <TextField {...params} {...textFieldProps} />
          )}
        />
      ) : (
        <TextField {...textFieldProps} />
      )}
    </Paper>
  );

  // const Input = ({ params }) => (
  //   <Paper
  //     className={`${className} paper`}
  //     style={{ padding: 0, margin: "0 0 20px 0", ...style }}
  //   >
  //     <TextField
  //       {...params}
  //       variant="outlined"
  //       fullWidth
  //       type="search"
  //       placeholder={placeholder}
  //       onChange={onChange}
  //     />
  //   </Paper>
  // );

  // return <Input />;

  // if (options) {
  //   return (
  //     <Autocomplete
  //       onChange={(e, item) => onSelect(item)}
  //       options={options}
  //       getOptionLabel={(item) => String(item)}
  //       renderInput={(params) => <Input params={params} />}
  //     />
  //   );
  // }

  // return <Input />;
};

export default Searchbox;
